<template>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 w-full">
    <b-card
      v-for="(item, index) in listSummary"
      :key="index"
      class="mb-2 border rounded-lg"
    >
      <div class="flex flex-col">
        <div class="flex items-center gap-5 mb-2">
          <div
            class="p-[3px] rounded w-fit"
            :class="item.color"
          >
            <img
              :src="item.icon"
              alt="icon"
              width="16px"
            >
          </div>
          <span class="text-[#626262] text-[14px]">{{ item.title }}</span>
        </div>
        <span class="text-black text-[24px] font-semibold">{{ item.value }}</span>
      </div>
    </b-card>
  </div>
</template>

<script>
import { listSummary } from '../config'

export default {
  props: {
    summaryData: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  data() {
    return {
      listSummary,
    }
  },
  watch: {
    summaryData: {
      immediate: true,
      handler(val) {
        this.listSummary[0].value = val?.totalUser || 0
        this.listSummary[1].value = val?.submitted || 0
        this.listSummary[2].value = val?.needRevision || 0
        this.listSummary[3].value = val?.live || 0
      },
    },
  },
}
</script>
